import {
  Button,
  ButtonSize,
  ButtonStyles,
  ButtonWidth,
  Drawer,
  NextgenDOMPurify,
  Theme,
  useTranslation,
} from '@nextgen-web-framework/all';
import { FC, useState } from 'react';
import { APointRedeemProductCard } from '../../Organisms';
import APointRedeemDrawer from '../APointRedeemDrawer/APointRedeemDrawer';
import styles from './APointRedeemInfoDrawer.module.scss';
import type { APointRedeemInfoDrawerPropsTypes } from './types/propsTypes';

const APointRedeemInfoDrawer: FC<APointRedeemInfoDrawerPropsTypes> = (props): JSX.Element => {
  const { productData, onClose, productQuantity } = props;
  const { aPointPriceCompanionText, aPointConditionsText = '' } = productData;

  const [closeDrawer, setCloseDrawer] = useState<boolean>(false);
  const [showRedeemDrawer, setShowRedeemDrawer] = useState(false);

  const showLink = productData.productFlags?.restrictFromPdpDisplay ? false : true;

  const t = useTranslation();

  const onHandleClick = (e: React.KeyboardEvent | React.MouseEvent | React.TouchEvent) => {
    if (onClose && typeof onClose === 'function') {
      onClose(e);
    }
    setCloseDrawer(true);
  };

  function handleRedeemBtnClick() {
    setShowRedeemDrawer(true);
    setCloseDrawer(true);
  }

  function handleRedeemDrawerCloseBtnClick() {
    setShowRedeemDrawer(false);
    setCloseDrawer(false);
  }

  return (
    <div className={styles['apoint-redeem-info-drawer-container']}>
      {!closeDrawer && (
        <Drawer
          header={
            <h5 className={styles['apoint-redeem-info-drawer-heading']}>{t('product.composite.common.details')}</h5>
          }
          closeOnBackdropClick={true}
          closeIcon={true}
          onClose={onHandleClick}
          bottomGap={0}
          footer={
            <div className={styles['apoint-redeem-info-drawer-footer']}>
              <Button
                id={'redeem-apoint'}
                title={t('product.composite.aPointRedeemCard.redeemBtn')}
                buttonStyle={ButtonStyles.SOLID}
                theme={Theme.BLACK}
                size={ButtonSize.SMALL}
                buttonWidth={ButtonWidth.FULL_WIDTH}
                tabIndex={0}
                disabled={false}
                data-testid="redeem-apoint-btn"
                onClick={handleRedeemBtnClick}
              />
            </div>
          }
          fullDraggable
        >
          <div className={styles['apoint-redeem-info-drawer-body']} data-testid="apoint-redeem-info-drawer-body-testid">
            <div className={styles['apoint-redeem-info-drawer-product-card-container']}>
              <APointRedeemProductCard
                productQuantity={productQuantity}
                showAPointAdditionalInfo={{ showProductId: true, showProductSize: true, showQuantity: true }}
                showLink={showLink}
                productData={productData}
              />
            </div>
            <div className={styles['info-container']}>
              <div className={styles['info-title-container']}>
                <h6 className={styles['info-title']}>{t('product.composite.aPointRedeemInfoDrawer.infoTitle')}</h6>
              </div>
              <div className={styles['info-content']}>
                <p className={styles['info-instruction-text']} data-testid="info-instruction-text-test-id">
                  {aPointPriceCompanionText}
                </p>
                <div
                  className={styles['info-details']}
                  dangerouslySetInnerHTML={{ __html: NextgenDOMPurify(aPointConditionsText) }}
                  data-testid="info-details-test-id"
                ></div>
              </div>
            </div>
          </div>
        </Drawer>
      )}
      {showRedeemDrawer && (
        <APointRedeemDrawer
          onClose={handleRedeemDrawerCloseBtnClick}
          showLink={showLink}
          productData={productData}
          productQuantity={productQuantity}
        />
      )}
    </div>
  );
};

export default APointRedeemInfoDrawer;
export type { APointRedeemInfoDrawerPropsTypes };
